module.exports = __webpack_public_path__ + "static/img/anxunu10.0c7a630f.svg";